import { BRIEF_CAMPAIGNS_LIST_QUERY_KEY } from "@entities/campaigns/lib/contsants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import {
  BRIEF_CONFIG_DELIVERABLE_FACETS_QUERY_KEY,
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  nextActionToTakeEnum,
} from "../constants";
import { BriefService } from "../services/brief.service";

export function usePurchaseInfluencer(
  briefId: string,
  handleCallback: (data: {
    nextActionToTake: nextActionToTakeEnum;
    result: {
      status: string;
      reason: string;
      briefInfluencer: IBriefInfluencerV2;
    }[];
  }) => void
) {
  const {
    mutate: purchase,
    isLoading: isPurchasing,
    isSuccess: isPurchased,
  } = useMutation({
    mutationFn: (briefInfluencerIds: string[]) =>
      BriefService.purchaseInfluencer(briefInfluencerIds).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, data) => {
      handleCallback(data.data);

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
      c.invalidateQueries({
        queryKey: BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId),
      });

      c.invalidateQueries({
        queryKey: BRIEF_CONFIG_DELIVERABLE_FACETS_QUERY_KEY(briefId),
      });
    },
  });

  return {
    purchase,
    isPurchasing,
    isPurchased,
  };
}
